export default "__VITE_ASSET__CrGk80Mz__"